import * as React from "react";
import { useLocation, useParams } from "react-router-dom";
import Button from "../../common/button/button";
import OrderStatus from "../my_orders/components/order_status";
import CustomCard from "../../common/custom_card/custom_card";
import Header from "../../common/header/header";
import Footer from "../../common/footer/footer";

interface OrderProps {
  orderNumber: string;
  droneName: string;
  orderedBy: string;
  date: string;
  time: string;
  location: string;
  status: string;
  price: number;
}

const defaultOrder: OrderProps = {
  orderNumber: "N/A",
  droneName: "N/A",
  orderedBy: "N/A",
  date: "N/A",
  time: "N/A",
  location: "N/A",
  status: "N/A",
  price: 0,
};

const DroneOrderDetails: React.FC = () => {
  const { orderNumber } = useParams();
  const location = useLocation();
  const order: OrderProps = location.state?.order || defaultOrder;

  return (
    <div className="h-full">
      <div className="max-w-7xl mx-auto p-4">
        <Header />
        <div className="py-20">
          <h1 className="text-3xl font-ubuntu font-bold mb-6">
            Order {orderNumber || order.orderNumber}
          </h1>
          <div className="bg-white rounded-lg border mb-6">
            <div className="flex justify-between items-start p-4">
              <div>
                <h2 className="text-base font-ubuntu font-semibold mb-2">
                  {order.droneName}
                </h2>
                <p className="font-ubuntu font-light text-primary">
                  Ordered by {order.orderedBy}
                </p>
                <p className="font-ubuntu text-primary">
                  {order.date}, {order.time}
                </p>
                <p className="font-ubuntu flex items-center mt-2 text-primary">
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  {order.location}
                </p>
              </div>
              <OrderStatus status={order.status} />
            </div>
            <div className="flex justify-between items-center p-4 border-t">
              <p className="font-ubuntu text-2xl font-medium text-primary">
                ${order.price}
              </p>
              <div>
                <Button buttonType="primary" className="mr-2">
                  Download Invoice 897887653
                </Button>
                <Button buttonType="secondary">Finalize order</Button>
              </div>
            </div>
          </div>
          <div>
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="bg-gray-100 p-4 rounded-lg">
                <h3 className="font-ubuntu font-semibold mb-2">
                  Drag photos here
                </h3>
                <p className="font-ubuntu text-sm text-gray-600">or</p>
                <Button buttonType="secondary" className="mt-2">
                  Upload
                </Button>
              </div>
              <div>
                <CustomCard
                  imageSrc=""
                  imageAlt=""
                  buttonText="Message Client"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DroneOrderDetails;
